import React from 'react';

import { MEASUREMENT_UNIT_SHORT_NAME } from '../../../common/constants';
import { Text } from '../../components';

const ProductMeasurementUnit = ({ product }) => (
	product && product.measurementUnit ? (
		<Text style={{ marginLeft: 5 }}>
			{ MEASUREMENT_UNIT_SHORT_NAME[product.measurementUnit] }
		</Text>
	) : null
);

export default React.memo(ProductMeasurementUnit);
